import axios from "@/axios";
import { SubscriptionCopy } from "@/enums";

const checkoutEndpoint = "/billing/checkout";
const portalEndpoint = "/billing/portal";
const subscriptionsEndpoint = "/subscriptions";
const paymentsEndpoint = "/payments";
const INACTIVE = SubscriptionCopy.STATE.INACTIVE;

const Billing = {
  async getSubscriptionSummary() {
    try {
      const summary = await axios.get(`${subscriptionsEndpoint}/summary`);
      return summary ?? null;
    } catch (error) {
      console.error("[Billing] Failed to fetch subscription summary", error);
      return null;
    }
  },

  async getSubscriptionStatus() {
    try {
      const data = await axios.get(`${subscriptionsEndpoint}/status`);

      return {
        status: data?.status ?? INACTIVE,
      };
    } catch (error) {
      console.error("[Billing] Failed to fetch subscription status", error);

      return {
        status: INACTIVE,
      };
    }
  },

  async getOrganizationPayments() {
    try {
      const data = await axios.get(`${paymentsEndpoint}/organization`);
      return data?.payments ?? [];
    } catch (error) {
      console.error("[Billing] Failed to fetch organization payments", error);
      return [];
    }
  },

  async getUserPayments() {
    try {
      const data = await axios.get(`${paymentsEndpoint}/user`)
      return data?.payments ?? []
    } catch (error) {
      console.error("[Billing] Failed to fetch user payments", error)
      return []
    }
  },

  async createCheckoutSession() {
    try {
      return await axios.post(checkoutEndpoint);
    } catch (error) {
      console.error("[Billing] Failed to create checkout session", error);

      return {
        clientSecret: null,
        sessionId: null,
      };
    }
  },

  async createPortalSession() {
    try {
      const data = await axios.post(portalEndpoint);
      return { url: data?.url ?? null };
    } catch (error) {
      console.error("[Billing] Failed to create portal session", error);
      return { url: null };
    }
  },
};

export default Billing;